module.exports = __webpack_public_path__ + "static/img/MentionCourse.a6f94d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/MentionCourse.png
// module id = bZFU
// module chunks = 1